//Action Types
export var INVOICES_RESET_ACTION_TYPE = "invoices/reset";
export var INVOICES_PREPARE_INVOICE_START_ACTION_TYPE = "invoices/prepare_invoice_start";
export var INVOICES_PREPARE_INVOICE_SUCCESS_ACTION_TYPE = "invoices/prepare_invoice_success";
export var INVOICES_CALCULATE_INVOICE_START_ACTION_TYPE = "invoices/calculate_invoice_start";
export var INVOICES_CALCULATE_INVOICE_SUCCESS_ACTION_TYPE = "invoices/calculate_invoicesuccess";
export var INVOICES_SAVE_INVOICE_START_ACTION_TYPE = "invoices/save_invoice_start";
export var INVOICES_SAVE_INVOICE_SUCCESS_ACTION_TYPE = "invoices/save_calculate_invoicesuccess";
export var INVOICES_UPDATE_INVOICE_START_ACTION_TYPE = "invoices/update_invoice_start";
export var INVOICES_UPDATE_INVOICE_SUCCESS_ACTION_TYPE = "invoices/update_calculate_invoicesuccess";
export var INVOICES_GET_INVOICE_START_ACTION_TYPE = "invoices/get_invoice_start";
export var INVOICES_GET_INVOICE_SUCCESS_ACTION_TYPE = "invoices/get_calculate_invoicesuccess";
export var INVOICES_ERROR_ACTION_TYPE = "invoices/error";
export var INVOICES_FETCH_TIPS_START_ACTION_TYPE = "invoices/fetch_tips_star";
export var INVOICES_FETCH_TIPS_SUCCESS_ACTION_TYPE = "invoices/fetch_tips_success";
export var INVOICES_SAVE_TIP_START_ACTION_TYPE = "invoices/save_tip_star";
export var INVOICES_SAVE_TIP_SUCCESS_ACTION_TYPE = "invoices/save_tip_success";
export var INVOICES_CREATE_DEPOSIT_INVOICE_START_ACTION_TYPE = "invoices/create_deposit_invoice_star";
export var INVOICES_CREATE_DEPOSIT_INVOICE_SUCCESS_ACTION_TYPE = "invoices/create_deposit_invoice_success";
export var INVOICES_FETCH_ADMIN_INVOICES_START_ACTION_TYPE = "invoices/fetch_admin_invoices_star";
export var INVOICES_FETCH_ADMIN_INVOICES_SUCCESS_ACTION_TYPE = "invoices/fetch_admin_invoices_success";
